module.exports = __webpack_public_path__ + "img/img_smart_img4.c048f440.png";